<template>
  <b-modal id="universitiesRemoveModal"
           class="universitiesRemoveModal"
           size="lg"
  >
    <template #modal-title>
      <h5>
        <em class="fas fa-times-circle"></em> Удаление вузов / СПО
      </h5>
    </template>

    <template #default>
      <div class="table" style="width: 100%; height: 40vh;">
        <ag-grid-vue
          class="remove-modal-grid ag-theme-material"
          :gridOptions="gridOptions"
          :rowData="chosenUniversities"
          :columnDefs="columnDefs"
          @onGridReady="onGridReady"
        >
        </ag-grid-vue>
      </div>
    </template>

    <template #modal-footer>
      <b-button cols="auto" @click="onSubmit"  variant="primary">
        <em class="fas fa-times-circle"></em> Удалить
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapActions } from 'vuex'
import organizationApi from '@/api/organization'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

export default {
  name: 'UniversitiesRemoveModal',
  data() {
    return {
      gridOptions: {
        defaultColDef: {
          headerName: '',
          autoHeight: false,
          sortable: true,
          headerClass: 'classes-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        localeText: AG_GRID_LOCALE_RU,
        pagination: true,
        paginationPageSize: 20,
        rowHeight: 90,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      columnDefs: [
        {
          headerName: 'Название',
          field: 'title',
          width: 370
        },
        {
          headerName: 'Город',
          field: 'city'
        },
        {
          headerName: 'Сайт',
          field: 'siteUrl'
        }
      ]
    }
  },
  props: {
    chosenUniversities: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
      this.gridApi.setDomLayout('autoHeight')
    },
    onSubmit() {
      organizationApi.removeOrganizations(this.chosenUniversities)
        .then(() => {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Вуз / СПО успешно удалено.'
          })
          this.$bvModal.hide('universitiesRemoveModal')
          this.$emit('universitiesRemoved')
        })
        .catch(() => {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Ошибка удаления вуза / СПО. ',
            error: true
          })
        })
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  },
  components: {
    'ag-grid-vue': AgGridVue
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/vendor/bootstrap/variables";

.remove-modal-grid {
  width: 100%;
  height: 100%;
}

.universitiesRemoveModal .table {
  justify-content: left;
}

.universities-table-header {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: left;
  color: #000;
  font-weight: bold;
}

.ag-theme-alpine {
  width: 100% !important;
  height: 20% !important;
}

.modal-footer {
  border: 0;
}

.universitiesRemoveModal .ag-row .ag-cell {
  justify-content: left;
  text-align: left;
}
.universitiesRemoveModal .ag-header-cell-label {
  justify-content: left;
}
</style>
